import { createApp } from '@app/adapters/create-app'
import PeriodPickerSidebarTrigger from '@app/application/layout/components/period-picker-sidebar-trigger.vue'

export default (doc: Document): void => {
  const triggers = doc.querySelectorAll(
    "[data-behaviour='period-picker-sidebar-trigger']"
  )

  triggers.forEach((trigger, key) => {
    const triggerElement = trigger as HTMLElement
    const app = createApp(
      PeriodPickerSidebarTrigger,
      {
        period: triggerElement.dataset.period,
        periodName: triggerElement.dataset.periodName,
        setCurrentLedger: triggerElement.dataset.setCurrentLedger === 'true',
        url: triggerElement.dataset.url,
        isVisibleForCustomer:
          triggerElement.dataset.isVisibleForCustomer === 'true',
        disabled: triggerElement.dataset.disabled === 'true',
        previousLedgerId: triggerElement.dataset.previousLedgerId,
        nextLedgerId: triggerElement.dataset.nextLedgerId,
      },
      {
        singletonId: `period-picker-sidebar-trigger-${key}`,
      }
    )

    app.mount(triggerElement)
  })
}
